import isNil from 'lodash/isNil';

export default function customPropTypeChainer(validation) {
    function checkType(isRequired, props, propName, componentName) {
        if (isNil(props[propName])) {
            if (isRequired) return new Error();
        } else {
            return validation(props, propName, componentName);
        }
    }

    const customPropType = checkType.bind(null, false);
    customPropType.isRequired = checkType.bind(null, true);

    return customPropType;
}
